<template>
  <div :height="true">
    <div class="main">
      <div class="back" @click="onClickBack"> 返回</div>
      <div class="title">{{title}}</div>
      <div class="sub-title">基本信息</div>
    </div> 
    <recruitment-form v-if="pageType" @cancel="onClickBack" :surveyId="surveyId" :pageType="pageType"></recruitment-form>
  </div>
</template>

<script>
import recruitmentForm from './RecruitmentForm'
import GlobalConfig from "@/global/config"

export default {
  components: { recruitmentForm },
  data() {
    return {
      surveyId: '',
      pageType: '', // visitor招募调查员，proxy招募代理
      title: '任务广场招募调查员'
    }
  },
  watch: {},
  computed: {},
  methods: {
    onClickBack() {
      //this.$router.back()
      if(this.pageType == 'proxy') {
        this.$router.push('/questionnaire/publish/proxy-executionq/index')
      } else {
        this.$router.push(`/survey/${GlobalConfig.getSurveyId()}/publish/random-interview/index`)
      } 
    }
  },
  created() {
    this.surveyId = GlobalConfig.getSurveyId()
    this.pageType = this.$route.query.pageType || 'visitor'
    if(this.pageType == 'proxy') {
      this.title = '任务广场招募代理'
    } else {
      this.title = '任务广场招募调查员'
    }
  },
  mounted() {}
}
</script>
<style lang="scss" scoped>
.release-recruitment{
  padding: 10px 20px;
  background-color: #fff;
}
.title {
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  border-bottom: 2px solid #e7e7eb;
  padding-bottom: 20px;
}
.main {
  padding: 20px 40px;
}
.sub-title {
  text-align: left;
  font-size: 15px;
  font-weight: 600;
  border-bottom: 1px solid #e7e7eb;
  padding: 0 0 13px 0;
}
::v-deep .el-card__body {
  padding: 0;
}
.back {
  position: relative;
  left: -20px;
  top: -5px;
  cursor: pointer;
}
</style>
